export default __webpack_public_path__ + "static/media/icon-individual-white.ccc2ebe3.svg";